import {GetColor} from 'lib/aphrodite/aphrodite';
import {LightboxTheme} from './model';

export const LightTheme: LightboxTheme = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        closeIconColor: GetColor('WhiteTextColor'),
        hoverIconColor: 'rgba(196, 196, 196, 0.2)',
    },
    lightbox: {
        backgroundColor: GetColor('TopLayerObjectBg'),
        color: GetColor('TextColor'),
        boxShadow: `0px 10px 20px ${GetColor('Shadow10')}`,
        closeIconColor: GetColor('Primary'),
        hoverIconColor: 'rgba(196, 196, 196, 0.2)',
    },
    header: {
        background: GetColor('TopLayerObjectBg'),
        color: GetColor('TextColor'),
        borderBottom: `1px solid ${GetColor('StrokeColor')}`,
    },
    body: {
        backgroundColor: undefined,
        color: undefined,
    },
    footer: {
        backgroundColor: undefined,
        color: undefined,
        botderTop: `1px solid ${GetColor('StrokeColor')}`,
    },
};
